import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { BookingStatus } from '../../../../../redux/booking/bookingSlice';

const StyledTypography = styled(Typography)<{
  isSmallScreen: boolean;
  bookingStatus: BookingStatus;
}>(({ isSmallScreen, bookingStatus, theme }) => ({
  fontSize: isSmallScreen ? '13px' : '15px',
  fontWeight: '600 !important',
  textAlign: 'start',
  background:
    bookingStatus === BookingStatus.CANCELED
      ? 'linear-gradient(180deg, #85B5C9 0%, #6CA3AC 100%)'
      : 'none',
  color: bookingStatus === BookingStatus.CANCELED ? 'transparent' : theme.palette.primary.main,
  WebkitBackgroundClip: bookingStatus === BookingStatus.CANCELED ? 'text' : 'unset',
  backgroundClip: bookingStatus === BookingStatus.CANCELED ? 'text' : 'unset',
}));

const BookingTimeSlot: React.FC<{ bookingAt: Date; bookingStatus: BookingStatus }> = ({
  bookingAt,
  bookingStatus,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const {
    i18n: { language },
  } = useTranslation();
  dayjs.locale(language);

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
      maxWidth="80px"
    >
      <StyledTypography isSmallScreen={isSmallScreen} bookingStatus={bookingStatus}>
        {dayjs(bookingAt).format('hh:mm')}
      </StyledTypography>
      <StyledTypography isSmallScreen={isSmallScreen} bookingStatus={bookingStatus}>
        {dayjs(bookingAt).format('A')}
      </StyledTypography>
    </Box>
  );
};

export default BookingTimeSlot;
